"use strict";
exports.__esModule = true;
var FieldBlock_1 = require("../../../components/StreamField/blocks/FieldBlock");
var StaticBlock_1 = require("../../../components/StreamField/blocks/StaticBlock");
var StructBlock_1 = require("../../../components/StreamField/blocks/StructBlock");
var ListBlock_1 = require("../../../components/StreamField/blocks/ListBlock");
var StreamBlock_1 = require("../../../components/StreamField/blocks/StreamBlock");
var wagtailStreamField = window.wagtailStreamField || {};
wagtailStreamField.blocks = {
    FieldBlock: FieldBlock_1.FieldBlock,
    FieldBlockDefinition: FieldBlock_1.FieldBlockDefinition,
    StaticBlock: StaticBlock_1.StaticBlock,
    StaticBlockDefinition: StaticBlock_1.StaticBlockDefinition,
    StructBlock: StructBlock_1.StructBlock,
    StructBlockDefinition: StructBlock_1.StructBlockDefinition,
    StructBlockValidationError: StructBlock_1.StructBlockValidationError,
    ListBlock: ListBlock_1.ListBlock,
    ListBlockDefinition: ListBlock_1.ListBlockDefinition,
    ListBlockValidationError: ListBlock_1.ListBlockValidationError,
    StreamBlock: StreamBlock_1.StreamBlock,
    StreamBlockDefinition: StreamBlock_1.StreamBlockDefinition,
    StreamBlockValidationError: StreamBlock_1.StreamBlockValidationError,
};
function initBlockWidget(id) {
    /*
    Initialises the top-level element of a BlockWidget
    (i.e. the form widget for a StreamField).
    Receives the ID of a DOM element with the attributes:
      data-block: JSON-encoded block definition to be passed to telepath.unpack
        to obtain a Javascript representation of the block
        (i.e. an instance of one of the Block classes below)
      data-value: JSON-encoded value for this block
    */
    var body = document.querySelector('#' + id + '[data-block]');
    // unpack the block definition and value
    var blockDefData = JSON.parse(body.dataset.block);
    var blockDef = window.telepath.unpack(blockDefData);
    var blockValue = JSON.parse(body.dataset.value);
    var blockErrors = window.telepath.unpack(JSON.parse(body.dataset.errors));
    // replace the 'body' element with the populated HTML structure for the block
    blockDef.render(body, id, blockValue, blockErrors);
}
window.initBlockWidget = initBlockWidget;
window.telepath.register('wagtail.blocks.FieldBlock', FieldBlock_1.FieldBlockDefinition);
window.telepath.register('wagtail.blocks.StaticBlock', StaticBlock_1.StaticBlockDefinition);
window.telepath.register('wagtail.blocks.StructBlock', StructBlock_1.StructBlockDefinition);
window.telepath.register('wagtail.blocks.StructBlockValidationError', StructBlock_1.StructBlockValidationError);
window.telepath.register('wagtail.blocks.ListBlock', ListBlock_1.ListBlockDefinition);
window.telepath.register('wagtail.blocks.ListBlockValidationError', ListBlock_1.ListBlockValidationError);
window.telepath.register('wagtail.blocks.StreamBlock', StreamBlock_1.StreamBlockDefinition);
window.telepath.register('wagtail.blocks.StreamBlockValidationError', StreamBlock_1.StreamBlockValidationError);
window.wagtailStreamField = wagtailStreamField;
